import React, { useState } from 'react';
import I18n from 'i18n-js';
import { IssueIcon } from 'components/cwo-icons';
import TicketModalForm from 'components/tickets-form/TicketModalForm';
import {
  arrayOf, bool, number, shape, string,
} from 'prop-types';

const Issue = ({
  ticketStatuses = [],
  ticketPriorities = [],
  ticketTypes = [],
  ticketCommitmentLevels = [],
  ticketDevStages = [],
  ticketDevStatuses = [],
  ticketSizes = [],
  ticketCwoModules = [],
  currentUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
    companyId: null,
  },
  responsibleUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
  canCreateTicket = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    canCreateTicket && (
      <>
        <button
          type="button"
          className="issue-btn btn btn-success"
          onClick={(e) => {
            e.currentTarget.blur();
            setIsModalOpen(true);
          }}
        >
          <IssueIcon />
          <span className="issue-btn__label">
            {I18n.t('shared.side_menu.issue')}
          </span>
        </button>

        <TicketModalForm
          currentUserInfo={currentUserInfo}
          statuses={ticketStatuses}
          priorities={ticketPriorities}
          ticketTypes={ticketTypes}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          newTicketModal={isModalOpen}
          ticketFromDashboard={false}
          responsibleUserInfo={responsibleUserInfo}
          commitmentLevels={ticketCommitmentLevels}
          devStages={ticketDevStages}
          devStatuses={ticketDevStatuses}
          sizes={ticketSizes}
          cwoModules={ticketCwoModules}
        />
      </>
    )
  );
};

Issue.propTypes = {
  currentUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
    companyId: number,
  }),
  ticketStatuses: arrayOf(string),
  ticketPriorities: arrayOf(string),
  ticketTypes: arrayOf(string),
  responsibleUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
  ticketCommitmentLevels: arrayOf(string),
  ticketDevStages: arrayOf(string),
  ticketDevStatuses: arrayOf(string),
  ticketSizes: arrayOf(string),
  ticketCwoModules: arrayOf(string),
  canCreateTicket: bool,
};

export default Issue;
